import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "masterplan-editor" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "breadcrumb"
}
const _hoisted_4 = { class: "steps-indicator" }
const _hoisted_5 = { class: "step-navigation" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = {
  key: 1,
  class: "step-back-placeholder",
  "aria-hidden": "true"
}
const _hoisted_8 = { class: "step-context" }
const _hoisted_9 = { class: "step-count" }
const _hoisted_10 = {
  key: 0,
  class: "content"
}
const _hoisted_11 = {
  key: 1,
  class: "content"
}
const _hoisted_12 = {
  key: 2,
  class: "content"
}
const _hoisted_13 = {
  key: 3,
  class: "content"
}
const _hoisted_14 = {
  key: 4,
  class: "content"
}
const _hoisted_15 = {
  key: 5,
  class: "content"
}
const _hoisted_16 = {
  key: 6,
  class: "content"
}
const _hoisted_17 = { class: "preview-container" }
const _hoisted_18 = { class: "preview-stats" }
const _hoisted_19 = { class: "stat" }
const _hoisted_20 = { class: "stat-value" }
const _hoisted_21 = { class: "stat" }
const _hoisted_22 = { class: "stat-value" }
const _hoisted_23 = { class: "stat" }
const _hoisted_24 = { class: "stat-value" }
const _hoisted_25 = {
  key: 0,
  class: "overwrite-warning"
}
const _hoisted_26 = { class: "save-actions" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 7,
  class: "confirm-modal"
}
const _hoisted_29 = { class: "modal-content" }
const _hoisted_30 = {
  key: 8,
  class: "loading-overlay"
}
const _hoisted_31 = {
  key: 9,
  class: "success-modal"
}
const _hoisted_32 = { class: "modal-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Interactive Masterplan Editor", -1)),
      ($setup.selectedEstate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", null, "Estate: " + _toDisplayString($setup.selectedEstate.title), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["step", { active: $setup.step === 'upload', completed: ['match', 'stages', 'estate-boundary', 'zoom', 'poi', 'preview'].includes($setup.step) }])
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "step-number" }, "1", -1),
        _createElementVNode("div", { class: "step-label" }, "Upload SVG", -1)
      ]))], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["step", { active: $setup.step === 'match', completed: ['stages', 'estate-boundary', 'zoom', 'poi', 'preview'].includes($setup.step) }])
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "step-number" }, "2", -1),
        _createElementVNode("div", { class: "step-label" }, "Assign Lots", -1)
      ]))], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["step", { active: $setup.step === 'stages', completed: ['estate-boundary', 'zoom', 'poi', 'preview'].includes($setup.step) }])
      }, [...(_cache[4] || (_cache[4] = [
        _createElementVNode("div", { class: "step-number" }, "3", -1),
        _createElementVNode("div", { class: "step-label" }, "Assign Stages", -1)
      ]))], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["step", { active: $setup.step === 'estate-boundary', completed: ['zoom', 'poi', 'preview'].includes($setup.step) }])
      }, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("div", { class: "step-number" }, "4", -1),
        _createElementVNode("div", { class: "step-label" }, "Estate Boundary", -1)
      ]))], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["step", { active: $setup.step === 'zoom', completed: ['poi', 'preview'].includes($setup.step) }])
      }, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("div", { class: "step-number" }, "5", -1),
        _createElementVNode("div", { class: "step-label" }, "Set Zoom Levels", -1)
      ]))], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["step", { active: $setup.step === 'poi', completed: $setup.step === 'preview' }])
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("div", { class: "step-number" }, "6", -1),
        _createElementVNode("div", { class: "step-label" }, "Points of Interest", -1)
      ]))], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["step", { active: $setup.step === 'preview' }])
      }, [...(_cache[8] || (_cache[8] = [
        _createElementVNode("div", { class: "step-number" }, "7", -1),
        _createElementVNode("div", { class: "step-label" }, "Preview & Save", -1)
      ]))], 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      ($setup.currentStepIndex > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "step-back",
            type: "button",
            "aria-label": `Back to ${$setup.wizardSteps[$setup.currentStepIndex - 1].label}`,
            onClick: $setup.goToPreviousStep
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { "aria-hidden": "true" }, "←", -1)),
            _createTextVNode("Back to " + _toDisplayString($setup.wizardSteps[$setup.currentStepIndex - 1].label), 1)
          ], 8, _hoisted_6))
        : _createCommentVNode("", true),
      ($setup.currentStepIndex === 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, "Step " + _toDisplayString($setup.currentStepIndex + 1) + " of " + _toDisplayString($setup.wizardSteps.length), 1),
        _createElementVNode("h2", null, _toDisplayString($setup.wizardSteps[$setup.currentStepIndex].label), 1)
      ])
    ]),
    ($setup.step === 'upload')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode($setup["MasterplanUpload"], {
            "estate-id": $setup.estateId,
            onUploadSuccess: $setup.handleUploadSuccess
          }, null, 8, ["estate-id"])
        ]))
      : _createCommentVNode("", true),
    ($setup.step === 'match')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          ($setup.uploadResult)
            ? (_openBlock(), _createBlock($setup["LotMatcher"], {
                key: 0,
                "svg-file": $setup.uploadResult.svgFile,
                elements: $setup.uploadResult.elements,
                "available-lots": $setup.estateLots,
                "initial-assignments": $setup.initialAssignments,
                onComplete: $setup.handleAssignmentComplete
              }, null, 8, ["svg-file", "elements", "available-lots", "initial-assignments"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ($setup.step === 'stages')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          ($setup.uploadResult)
            ? (_openBlock(), _createBlock($setup["StageDrawer"], {
                key: 0,
                "svg-file": $setup.uploadResult.svgFile,
                assignments: $setup.assignments,
                "available-lots": $setup.estateLots,
                stages: $setup.estateStages,
                "initial-stage-boundaries": $setup.initialStageBoundaries,
                "initial-stage-label-metadata": $setup.initialStageLabelMetadata,
                onComplete: $setup.handleStageComplete
              }, null, 8, ["svg-file", "assignments", "available-lots", "stages", "initial-stage-boundaries", "initial-stage-label-metadata"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ($setup.step === 'estate-boundary')
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          ($setup.uploadResult)
            ? (_openBlock(), _createBlock($setup["EstateBoundaryDrawer"], {
                key: 0,
                "svg-file": $setup.uploadResult.svgFile,
                "estate-title": $setup.selectedEstate?.title || '',
                "estate-id": $setup.estateId,
                "user-id": $setup.store.state.user.data._id,
                "initial-boundary-path": $setup.initialEstateBoundaryPath,
                "initial-label-metadata": $setup.initialEstateLabelMetadata,
                onComplete: $setup.handleEstateBoundaryComplete
              }, null, 8, ["svg-file", "estate-title", "estate-id", "user-id", "initial-boundary-path", "initial-label-metadata"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ($setup.step === 'zoom')
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          ($setup.uploadResult)
            ? (_openBlock(), _createBlock($setup["ZoomLevelsEditor"], {
                key: 0,
                "svg-file": $setup.uploadResult.svgFile,
                stages: $setup.stageAssignments,
                "estate-boundary-path": $setup.estateBoundaryPath || undefined,
                "initial-zoom-levels": $setup.zoomLevels,
                "initial-preview-state": $setup.zoomPreviewState,
                "initial-estate-zoom-center": $setup.estateZoomCenter,
                "initial-stage-zoom-center": $setup.stageZoomCenter,
                "available-stages": $setup.estateStages,
                lots: $setup.enrichedAssignments,
                "available-lots": $setup.estateLots,
                "stage-label-metadata": $setup.stageLabelMetadata,
                "estate-label-metadata": $setup.estateLabelMetadata || undefined,
                "estate-name": $setup.selectedEstate?.title || '',
                "land-subdivision": $setup.selectedEstate?.type === $setup.EstateType.LAND_SUBDIVISION,
                onComplete: $setup.handleZoomComplete
              }, null, 8, ["svg-file", "stages", "estate-boundary-path", "initial-zoom-levels", "initial-preview-state", "initial-estate-zoom-center", "initial-stage-zoom-center", "available-stages", "lots", "available-lots", "stage-label-metadata", "estate-label-metadata", "estate-name", "land-subdivision"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ($setup.step === 'poi')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          ($setup.uploadResult)
            ? (_openBlock(), _createBlock($setup["PointsOfInterestEditor"], {
                key: 0,
                "svg-file": $setup.uploadResult.svgFile,
                "estate-id": $setup.estateId,
                "user-id": $setup.store.state.user.data._id,
                "initial-pois": $setup.pointsOfInterest,
                onComplete: $setup.handlePoiComplete
              }, null, 8, ["svg-file", "estate-id", "user-id", "initial-pois"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ($setup.step === 'preview')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[14] || (_cache[14] = _createElementVNode("h2", null, "Preview Interactive Masterplan", -1)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "stat-label" }, "Total Lots Mapped", -1)),
                _createElementVNode("div", _hoisted_20, _toDisplayString($setup.assignments.length), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "stat-label" }, "Stages with Boundaries", -1)),
                _createElementVNode("div", _hoisted_22, _toDisplayString($setup.stageAssignments.length), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "stat-label" }, "Estate", -1)),
                _createElementVNode("div", _hoisted_24, _toDisplayString($setup.selectedEstate?.title || "Unknown"), 1)
              ])
            ]),
            ($setup.existingMasterplanId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[13] || (_cache[13] = [
                  _createElementVNode("span", null, "⚠️ You are overwriting an existing masterplan for this estate.", -1)
                ]))]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: $setup.handleSave,
                disabled: $setup.saving
              }, _toDisplayString($setup.saving ? "Saving..." : $setup.existingMasterplanId ? "Overwrite Masterplan" : "Save Masterplan"), 9, _hoisted_27),
              _createElementVNode("button", {
                class: "btn-secondary",
                onClick: $setup.handleCancel
              }, "Cancel")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.showOverwriteConfirm && !$setup.loadingExisting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "modal-overlay" }, null, -1)),
          _createElementVNode("div", _hoisted_29, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "warn-icon" }, "⚠️", -1)),
            _cache[18] || (_cache[18] = _createElementVNode("h3", null, "Masterplan Already Exists", -1)),
            _createElementVNode("p", null, [
              _cache[15] || (_cache[15] = _createTextVNode("A masterplan already exists for ", -1)),
              _createElementVNode("strong", null, _toDisplayString($setup.selectedEstate?.title), 1),
              _cache[16] || (_cache[16] = _createTextVNode(". What would you like to do?", -1))
            ]),
            _createElementVNode("div", { class: "modal-actions" }, [
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: $setup.editExisting
              }, "Edit Existing"),
              _createElementVNode("button", {
                class: "btn-danger",
                onClick: $setup.startFresh
              }, "Start Fresh (Overwrite)"),
              _createElementVNode("button", {
                class: "btn-secondary",
                onClick: $setup.cancelOverwrite
              }, "Cancel")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.loadingExisting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [...(_cache[20] || (_cache[20] = [
          _createElementVNode("div", { class: "loading-content" }, [
            _createElementVNode("div", { class: "loading-spinner" }),
            _createElementVNode("p", null, "Loading masterplan data…")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    ($setup.showSuccess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "modal-overlay" }, null, -1)),
          _createElementVNode("div", _hoisted_32, [
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "success-icon" }, "✓", -1)),
            _createElementVNode("h3", null, _toDisplayString($setup.existingMasterplanId ? "Masterplan Updated Successfully!" : "Masterplan Saved Successfully!"), 1),
            _createElementVNode("p", null, "The interactive masterplan has been " + _toDisplayString($setup.existingMasterplanId ? "updated" : "created") + " for " + _toDisplayString($setup.selectedEstate?.title), 1),
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/admin/estates')))
            }, "Go to Estates")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}